/* Jump links */

export function jump_links() {

	( ( $ ) => {

		const init = () => {

			$( 'a[href^="#"]' ).on( 'click', ( ev ) => {
				const uri_link = $( ev.currentTarget ).prop( 'href' ).split( '#' );

				if ( uri_link[1].length == 0 ) {
					return;
				}

				const target_id = `#${uri_link[1]}`;
				const target_position = parseInt( $( target_id ).offset().top - window.COVE.navbar_total_height );

				$( 'html, body' ).animate( {
					scrollTop: target_position
				} );
			} );
		}

		init();

	} )( window.jQuery );

}
